import { render, staticRenderFns } from "./sendContactStatementDialog.vue?vue&type=template&id=7422f6b1&"
import script from "./sendContactStatementDialog.vue?vue&type=script&lang=js&"
export * from "./sendContactStatementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports